import { Id, DomainEntity, Json } from "@homeleite/arch";
import { AnimalEvent, AnimalSummary, EventType } from "../..";
import { HerdoutType } from './herdout-type';
import { HerdoutReasonSummary } from './reasons/herdout-reason-summary';
import { AuditData } from '../../auditData';

export abstract class Herdout implements DomainEntity, AnimalEvent {

    constructor(
        public readonly id = Id.gen(),
        public date: Date = null,
        public animal: AnimalSummary = new AnimalSummary(),
        public type: string = EventType.HERDOUT.name,
        public created: Date = null,
        public auditData: AuditData = null,
        public milkControlId: string = null
    ) { }

    toJson() {
        return Json.to.simple(this, {
            animal: this.animal.toJson(),
        });
    }

    static fromJson(json: any): Herdout {

        if (json.type == null) {
            return null;
        }

        switch (json.type) {
            case HerdoutType.DEATH.name:
                return HerdoutDeath.fromJson(json);
            case HerdoutType.DISCARD.name:
                return HerdoutDiscard.fromJson(json);
            case HerdoutType.SALE.name:
                return HerdoutSale.fromJson(json);
            default:
                `Herdout [ type: ${json.type} ] not mapped`
        }
    }
}

export class HerdoutDeath extends Herdout {

    constructor(
        public readonly id = Id.gen(),
        public date: Date = null,
        public animal: AnimalSummary = new AnimalSummary(),
        public deathCause: HerdoutReasonSummary = new HerdoutReasonSummary(),
        public type: string = HerdoutType.DEATH.name,
        public created: Date = null,
        public auditData: AuditData = null
    ) {
        super(id, date, animal, type, created, auditData);
    }

    toJson() {
        return Json.to.simple(this, {
            date: this.date?.toISOString() ?? null,
            animal: this.animal?.toJson() ?? null,
            deathCause: this.deathCause?.toJson() ?? null,
            type: HerdoutType.DEATH.name
        });
    }

    static fromJson(json: HerdoutDeath) {
        return Json.from.simple(json, HerdoutDeath, {
            date: json.date ? new Date(json.date) : null,
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
            deathCause: json.deathCause ? HerdoutReasonSummary.fromJson(json.deathCause) : null,
            created: json.created ? new Date(json.created) : null,
            auditData: json.auditData ? AuditData.fromJson(json.auditData) : null
        });
    }
}

export class HerdoutDiscard extends Herdout {

    constructor(
        public readonly id = Id.gen(),
        public date: Date = null,
        public animal: AnimalSummary = new AnimalSummary(),
        public discardCause: HerdoutReasonSummary = new HerdoutReasonSummary(),
        public type: string = HerdoutType.DISCARD.name,
        public created: Date = null,
        public auditData: AuditData = null
    ) {
        super(id, date, animal, type, created, auditData);
    }

    toJson() {
        return Json.to.simple(this, {
            date: this.date.toISOString() ?? null,
            animal: this.animal?.toJson() ?? null,
            discardCause: this.discardCause?.toJson() ?? null,
            type: HerdoutType.DISCARD.name
        });
    }

    static fromJson(json: HerdoutDiscard) {
        return Json.from.simple(json, HerdoutDiscard, {
            date: json.date ? new Date(json.date) : null,
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
            discardCause: json.discardCause ? HerdoutReasonSummary.fromJson(json.discardCause) : null,
            created: json.created ? new Date(json.created) : null,
            auditData: json.auditData ? AuditData.fromJson(json.auditData) : null
        });
    }
}

export class HerdoutSale extends Herdout {

    constructor(
        public readonly id = Id.gen(),
        public date: Date = null,
        public animal: AnimalSummary = new AnimalSummary(),
        public saleCause: HerdoutReasonSummary = new HerdoutReasonSummary(),
        public type: string = HerdoutType.SALE.name,
        public created: Date = null,
        public auditData: AuditData = null
    ) {
        super(id, date, animal, type, created, auditData);
    }

    toJson() {
        return Json.to.simple(this, {
            date: this.date.toISOString() ?? null,
            animal: this.animal?.toJson() ?? null,
            saleCause: this.saleCause?.toJson() ?? null,
            type: HerdoutType.SALE.name
        });
    }

    static fromJson(json: HerdoutSale) {
        return Json.from.simple(json, HerdoutSale, {
            date: json.date ? new Date(json.date) : null,
            animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
            saleCause: json.saleCause ? HerdoutReasonSummary.fromJson(json.saleCause) : null,
            created: json.created ? new Date(json.created) : null,
            auditData: json.auditData ? AuditData.fromJson(json.auditData) : null
        });
    }
}
